import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';
import { StoryblokService } from '../services/storyblok.service';
import { ConversionFormat } from '../tools/convert/templates/conversion-template/conversion-template.component';
// import { Components } from './components';
import { containsComponent } from './storyblok-find-components';

export const storyblokToolsConvertFromFormatsResolver: ResolveFn<Observable<ConversionFormat[]>> = route => {
  const path = route.url.map(segment => segment.path).join('/') || 'home';
  const storyBlockService = inject(StoryblokService);
  return storyBlockService.getStory(path, route).pipe(
    switchMap(resp => {
      const story = resp && resp.story;
      if (!story) return of(undefined);
      return storyBlockService.resolveRelationships(route).pipe(
        switchMap(relationships => {
          const componentTypes: unknown[] = ['ConvertFromFormatList'];
          if (componentTypes.some(type => containsComponent([story.content, ...relationships], type))) {
            return storyBlockService.getStories({ content_type: 'ImageFormat' }) as Observable<ConversionFormat[]>;
          }
          return of(undefined);
        })
      );
    })
  );
};
